import { c as _c } from "react/compiler-runtime";
import { useSubscribedCoupon } from './useSubscribedCoupon.js';
const createDTO = board => {
  // Returns stable reference using Zustand useShallow
  // Reduction should be user friendly (non binary format, only for internal usage)
  return {
    quickPickSize: board.quickPickSize,
    mOutcomes: board.mOutcomes,
    uOutcomes: board.uOutcomes
  };
};
/**
 * Gets the view model representation of a given coupon.
 *
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @param root0.couponIndex Specific coupon id in order
 * @param root0.boardIndex Specific board id in order
 * @returns Coupon model without boards
 */
export function useCouponBoard(t0) {
  const $ = _c(6);
  const {
    couponId,
    couponIndex,
    boardIndex
  } = t0;
  let t1;
  if ($[0] !== boardIndex) {
    t1 = coupon => {
      if (!coupon) {
        return;
      }
      const board = coupon.boards[boardIndex];
      if (!board) {
        return;
      }
      return createDTO(board);
    };
    $[0] = boardIndex;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== couponId || $[3] !== couponIndex || $[4] !== t1) {
    t2 = {
      couponId,
      couponIndex,
      selector: t1
    };
    $[2] = couponId;
    $[3] = couponIndex;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const board_0 = useSubscribedCoupon(t2);
  return board_0;
}